/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Row,
} from 'react-bootstrap';
import deviceActions from 'loraactions/device';
import IntlMsg from 'lorautils/intl/IntlMsg';
import ErrorSet from 'lorautils/errors/ErrorSet';
import Refresher from 'loracoms/Refresher';
import {
  isHexString,
  isInteger,
} from 'lorautils/checkers/numbers';
import RichButton from 'loracoms/RichButton';
import SelectPills from 'loracoms/SelectPills';
import Nvl from 'loracoms/Nvl';
import ControlTips from 'loracoms/ControlTips';
import styles from './styles.scss';


const propTypes = {
  intl: React.PropTypes.any.isRequired,
  txSize: React.PropTypes.object.isRequired,
  deviceId: React.PropTypes.string.isRequired,
  sendData: React.PropTypes.func.isRequired,
  flushTx: React.PropTypes.func.isRequired,
  getTxSize: React.PropTypes.func.isRequired,
  sent: React.PropTypes.object.isRequired,
  flushed: React.PropTypes.object.isRequired,
};

const EncodingOptions = [{
  name: 'HEX',
  value: 'hex',
  active: true,
}, {
  name: 'TEXT',
  value: 'text',
}];

class SendData extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      txSize: props.txSize,
      encoding: 'hex',
      errors: (
        new ErrorSet()
          .add('FE_EMPTY', 'port')
          .add('FE_EMPTY', 'data')
      ),
    };
    this.intlMsg = new IntlMsg(props.intl, 'devicedetail.datatoolview.senddata');
    this.handleChangePort = this.handleChangePort.bind(this);
    this.handleChangeEncoding = this.handleChangeEncoding.bind(this);
    this.handleChangeData = this.handleChangeData.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFlushTx = this.handleFlushTx.bind(this);
    this.handleReloadTxSize = this.handleReloadTxSize.bind(this);
  }

  componentWillMount() {
    const { getTxSize, deviceId } = this.props;
    getTxSize(deviceId);
  }

  componentWillReceiveProps(nextProps) {
    const { txSize, sent, flushed } = nextProps;
    if (txSize !== this.props.txSize) {
      this.setState({ txSize });
    }
    if (sent !== this.props.sent) {
      this.setState({ sentStatus: sent.status });
      if (sent.status === 'success') {
        const { getTxSize, deviceId } = this.props;
        getTxSize(deviceId);
      }
    }
    if (flushed !== this.props.flushed) {
      this.setState({ flushStatus: flushed.status });
      if (flushed.status === 'success') {
        const { getTxSize, deviceId } = this.props;
        getTxSize(deviceId);
      }
    }
  }

  checkPort(port) {
    const { errors } = this.state;

    if (isNil(port) || port === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'port') });
      return false;
    }

    if (!isInteger(port, { min: 1, max: 223 })) {
      this.setState({ errors: errors.add('FE_INVALIDPORT', 'port') });
      return false;
    }

    this.setState({ errors: errors.remove('port') });
    return true;
  }

  checkData(data, encoding) {
    const { errors } = this.state;

    if (isNil(data) || data === '') {
      this.setState({ errors: errors.add('FE_EMPTY', 'data') });
      return false;
    }

    if (encoding === 'hex') {
      if (!isHexString(data, { pair: true })) {
        this.setState({ errors: errors.add('FE_INVALIDHEX', 'data') });
        return false;
      }
    }

    this.setState({ errors: errors.remove('data') });
    return true;
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({ submitted: true });

    const { errors } = this.state;
    if (!errors.isEmpty()) {
      return;
    }

    const { deviceId, sendData } = this.props;
    const { port, data, encoding } = this.state;
    sendData(deviceId, Number(port), data, encoding);
  }

  handleFlushTx() {
    const { deviceId, flushTx } = this.props;
    flushTx(deviceId);
  }

  handleChangePort(e) {
    const port = e.target.value.trim();
    this.setState({ port });
    this.checkPort(port);
  }

  handleChangeEncoding(encoding) {
    this.setState({ encoding });

    const { data } = this.state;
    this.checkData(data, encoding);
  }

  handleChangeData(e) {
    const data = e.target.value;
    this.setState({ data });

    const { encoding } = this.state;
    this.checkData(data, encoding);
  }

  handleReloadTxSize() {
    const { getTxSize, deviceId } = this.props;
    getTxSize(deviceId);
  }

  render() {
    const {
      port = '',
      encoding,
      data = '',
      txSize,
      errors,
      submitted = false,
      sentStatus = '',
      flushStatus = '',
    } = this.state;
    const { data: { size } = {} } = txSize;

    return (
      <Row>
        <Col md={8}>
          <div className={styles.sendForm}>
            <Form
              horizontal
              onSubmit={this.handleSubmit}
            >
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('port')}
                  </ControlLabel>
                </Col>
                <Col md={6}>
                  <FormControl
                    bsClass="aisz-form-control-f"
                    value={port}
                    onChange={this.handleChangePort}
                    placeholder={this.intlMsg.msg('port.placeholder')}
                  />
                  <ControlTips
                    show={errors.has('port') && submitted}
                    message={this.intlMsg.errorMsg(errors.get('port'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('encoding')}
                  </ControlLabel>
                </Col>
                <Col md={6}>
                  <SelectPills
                    options={EncodingOptions}
                    value={encoding}
                    onChange={selected => this.handleChangeEncoding(selected[0])}
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col md={3}>
                  <ControlLabel className="aisz-control-label">
                    {this.intlMsg.msg('data')}
                  </ControlLabel>
                </Col>
                <Col md={6}>
                  <FormControl
                    bsClass="aisz-form-control-f"
                    value={data}
                    onChange={this.handleChangeData}
                    placeholder={this.intlMsg.msg(`data.placeholder.${encoding}`)}
                  />
                  <ControlTips
                    show={errors.has('data') && submitted}
                    message={this.intlMsg.errorMsg(errors.get('data'))}
                    azStyle="danger"
                  />
                </Col>
              </FormGroup>
              <FormGroup>
                <Col mdOffset={3} md={6}>
                  <RichButton
                    status={sentStatus}
                    states={[{
                      status: 'default',
                      label: (
                        <span>
                          <span className="halflings halflings-send" />{' '}
                          {this.intlMsg.msg('send')}
                        </span>
                      ),
                      type: 'submit',
                    }, {
                      status: 'pending',
                      style: 'info',
                      label: <span><i className="fa fa-spinner fa-spin" />{' '}{this.intlMsg.msg('sending')}</span>,
                    }, {
                      status: 'success',
                      style: 'success',
                      label: this.intlMsg.msg('sendsuccess'),
                      timer: () => this.setState({ sentStatus: '' }),
                    }, {
                      status: 'failure',
                      style: 'danger',
                      label: this.intlMsg.msg('sendfailure'),
                      timer: () => this.setState({ sentStatus: '' }),
                    }]}
                  />
                </Col>
              </FormGroup>
            </Form>
          </div>

        </Col>
        <Col md={4}>
          <div className={styles.txSize}>
            <div className={`${styles.label} ${styles.marginRightO}`}>
              {this.intlMsg.msg('txsize')}
              <span className={styles.refresher}>
                <Refresher
                  onReload={this.handleReloadTxSize}
                  reloading={txSize.status === 'pending'}
                />
              </span>
            </div>
            <div className={`${styles.value} ${styles.marginRight}`}>
              <Nvl val={size} status={txSize.status} />
            </div>
            <div className={styles.marginRight}>
              <RichButton
                status={flushStatus}
                states={[{
                  status: 'default',
                  style: 'link-warning',
                  label: (
                    <span>
                      {this.intlMsg.msg('flushtx')}
                    </span>
                  ),
                  onClick: this.handleFlushTx,
                }, {
                  status: 'pending',
                  style: 'link-default',
                  label: (
                    <span>
                      <i className="fa fa-spinner fa-spin" />{' '}
                      {this.intlMsg.msg('flushing')}
                    </span>
                  ),
                }]}
              />
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

SendData.propTypes = propTypes;


const mapStateToProps = state => ({
  txSize: state.device.getTxSize,
  sent: state.device.sendDeviceData,
  flushed: state.device.flushTx,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getTxSize: deviceActions.getTxSize,
  sendData: deviceActions.sendDeviceData,
  flushTx: deviceActions.flushTx,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(SendData));




// WEBPACK FOOTER //
// ./src/containers/Application/coms/DeviceDetail/coms/DataToolView/coms/SendData/index.jsx